const descriptorForm = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl:
    '/modules/packageManagement/descriptor-management/descriptor-form/descriptor-form.html',
  controller: 'descriptorFormController',
};

angular
  .module('package-management.module')
  .component('descriptorForm', descriptorForm);
